import { Controller } from "@hotwired/stimulus"

// Onboarding `auth` step companion. Two jobs:
//   1. Toggle the email-fallback form open when the user taps
//      "Continue with email".
//   2. At submit-time, stamp the onboarding answers (held by the parent
//      onboarding controller in window.__onboardingPayload) into the
//      hidden `onboarding_payload` field — the registrations controller
//      treats a request without it as not-found, so the field MUST be
//      populated by the time the form leaves the page.
export default class extends Controller {
  static targets = ["emailToggle", "emailForm", "payloadField", "socialGroup"]

  toggleEmail(event) {
    event?.preventDefault()
    if (!this.hasEmailFormTarget) return

    this.socialGroupTargets.forEach((el) => { el.hidden = true })
    this.emailFormTarget.hidden = false

    const firstInput = this.emailFormTarget.querySelector("input[type='email']")
    firstInput?.focus()
  }

  showSocial(event) {
    event?.preventDefault()
    if (this.hasEmailFormTarget) this.emailFormTarget.hidden = true
    this.socialGroupTargets.forEach((el) => { el.hidden = false })
  }

  connect() {
    if (this.hasEmailFormTarget) {
      this.emailFormTarget.addEventListener("submit", this.stampPayload)
    }
  }

  disconnect() {
    if (this.hasEmailFormTarget) {
      this.emailFormTarget.removeEventListener("submit", this.stampPayload)
    }
  }

  stampPayload = () => {
    if (!this.hasPayloadFieldTarget) return
    const payload = window.__onboardingPayload
    this.payloadFieldTarget.value = payload ? JSON.stringify(payload) : ""
  }
}
